import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../../Security/firebase-config';
import { useAuth } from '../../context/AuthContext';
import { useTeam } from '../../context/TeamContext';
import { FUNCTION_NAMES } from '../../utils/functionNames';
import { buildDesktopInviteLink } from '../../utils/teamInviteLinks';
import TeamInviteView from '../team-invite/TeamInviteView';
import useInvitePreview from '../team-invite/useInvitePreview';
export default function JoinTeam() {
 const [search]=useSearchParams(); const token=search.get('token'); const navigate=useNavigate();
 const {loading}=useAuth(); const {setTeamId}=useTeam(); const [busy,setBusy]=useState(false); const [error,setError]=useState('');
 const preview=useInvitePreview(functions,token);
 const valid=!!token && /^[A-Za-z0-9_-]{10,200}$/.test(token);
 async function join() {
  if(!valid || preview.loading || preview.error || busy || !auth.currentUser)return;
  setBusy(true);setError('');
  try {
   const result=await httpsCallable(functions,FUNCTION_NAMES.joinTeamByInvite)({token});
   if(!result.data?.pendingJoin) await setTeamId(result.data.teamId);
   navigate('/team-center/dashboard?teamId='+encodeURIComponent(result.data.teamId));
  }catch(e){setError(e?.message || 'Unable to join this team.');}finally{setBusy(false);}
 }
 return <TeamInviteView preview={preview} signedIn={!!auth.currentUser} checkingAuth={loading} busy={busy} error={error} onJoin={join} desktopUrl={buildDesktopInviteLink(token || '')} loginUrl={'/login?next='+encodeURIComponent('/join?token='+encodeURIComponent(token || ''))}/>;
}
